import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface EmptyListingsBlockProps {
  query: string;
  shopsLowestPrice?: number | null;
  shopsCount?: number;
}

export function EmptyListingsBlock({
  query,
  shopsLowestPrice = null,
  shopsCount = 0,
}: EmptyListingsBlockProps) {
  const { t } = useTranslation();

  return (
    <section className="mt-4 rounded-xl border border-dashed border-gray-300 bg-gradient-to-br from-primary-50/40 to-white p-5">
      <div className="flex items-start gap-3">
        <div className="hidden h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-primary-700 ring-1 ring-primary-100 sm:flex">
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.4-1.4A2 2 0 0118 14.2V11a6 6 0 10-12 0v3.2c0 .5-.2 1-.6 1.4L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="text-base font-semibold text-gray-900">
            {t("search.no_listings_title", `Skelbimų pagal „${query}" kol kas nėra`, { query })}
          </h2>

          <div className="mt-3 flex flex-wrap items-center gap-2">
            <Link
              to={`/wishlists?q=${encodeURIComponent(query)}`}
              className="inline-flex items-center gap-1.5 rounded-md bg-primary-800 px-3 py-1.5 text-sm font-semibold text-white hover:bg-primary-900"
            >
              🔔 {t("search.no_listings_notify_cta", "Pranešti, kai atsiras")}
            </Link>
            {shopsCount > 0 && shopsLowestPrice != null && (
              <Link
                to={`/listings?q=${encodeURIComponent(query)}`}
                className="inline-flex items-center gap-1 rounded-md border border-gray-200 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 hover:border-gray-300 hover:bg-gray-50"
              >
                {t(
                  "search.no_listings_shops_hint",
                  `Parduotuvėse nuo ${shopsLowestPrice.toFixed(2)} €`,
                  { price: shopsLowestPrice.toFixed(2) }
                )}
              </Link>
            )}
          </div>

          <div className="mt-4 rounded-lg bg-white/80 p-3 ring-1 ring-gray-100">
            <p className="text-sm text-gray-700">
              {t(
                "search.no_listings_sell_hint",
                "Turi savo kopiją? Tokie žaidimai dažnai parduodami per kelias dienas."
              )}
            </p>
            <Link
              to="/listings/new"
              className="mt-2 inline-flex items-center gap-1 text-sm font-semibold text-primary-800 hover:text-primary-900"
            >
              {t("search.no_listings_sell_cta", "Skelbti savo kopiją")}
              <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.4}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
